module.exports = __webpack_public_path__ + "static/media/bunbury-fishing-club.11252be9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/bunbury-fishing-club.jpg
// module id = 189
// module chunks = 0